import { schema } from "normalizr";
export const comment = new schema.Entity("comments");
export const document = new schema.Entity("documents", {
  comments: [comment]
}, {
  idAttribute: "documentId"
});
export const classificationListSchema = new schema.Entity("classifications", {
  documents: [document]
}, {
  idAttribute: "documentRequestId"
});
export const sampleDocument = new schema.Entity("sampleDocuments", {
  documents: [document]
}, {
  idAttribute: "documentId"
});